
<template>
  <div v-if="convId != null" class="chat__header">
    <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
      <div class="relative flex items-center mr-4">
        <vs-avatar
          class="m-0 border-2 border-solid border-white"
          size="40px"
          :color="venue.style.colorBackground"
          :src="venue.logoUrl"
        />
        <h6 class="ml-2 mr-4">{{ venue.name }}</h6>
        <div class="flex flex-col">
          <span class="h-4 flex items-center">
            <feather-icon icon="PhoneIcon" svgClasses="w-3 h-3'"></feather-icon>
            <span class="ml-2 text-sm"> {{ venue.phoneCountryCode }}{{ venue.phone }} </span>
          </span>
          <span class="h-4 flex items-center">
            <feather-icon icon="MailIcon" svgClasses="w-3 h-3'"></feather-icon>
            <span class="ml-2 text-sm">
              {{ venue.email }}
            </span>
          </span>
          <span class="h-4 flex items-center">
            <feather-icon icon="GlobeIcon" svgClasses="w-3 h-3'"></feather-icon>
            <span class="ml-2 text-sm">
              <a :href="'https://' + venue.website" target="_blank">https://{{ venue.website }}</a>
            </span>
          </span>
        </div>
      </div>
      <vs-spacer></vs-spacer>

      <vs-chip :color="conversation.guestId ? 'rgba(0, 100, 0, 0.3)' : 'rgba(100, 0, 0, 0.3)'">
        <div
          class="relative flex items-center cursor-pointer"
          @click.stop="$emit('showProfileSidebar', convId)"
        >
          <h6 class="mr-2">{{ userDetails.firstName + " " + userDetails.lastName }}</h6>

          <!-- Show UserCheckIcon if found -->
          <!-- Show UserXIcon if not found -->
          <feather-icon
            :icon="conversation.guestId ? 'UserCheckIcon' : 'UserXIcon'"
            svgClasses="w-6 h-6 text-dark"
          ></feather-icon>
        </div>
      </vs-chip>
    </vs-navbar>
  </div>
</template>

<script>
export default {
  props: {
    convId: {
      type: String,
      required: true,
    },
    isPinnedProp: {
      type: Boolean,
      required: true,
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    conversation() {
      return this.$store.getters["chat/activeConversation"];
    },
    venue() {
      return this.$store.getters["venues/venue"](this.conversation.venueId);
    },
    isPinnedLocal: {
      get() {
        return this.isPinnedProp;
      },
      set(val) {
        const chatData = this.$store.getters["chat/activeConversation"];
        if (chatData) {
          const payload = { id: this.convId, value: val };
          this.$store
            .dispatch("chat/toggleIsPinned", payload)
            .then(() => {
              this.$emit("toggleIsChatPinned", val);
            })
            .catch(err => {
              console.error(err);
            });
        } else {
          this.$emit("toggleIsChatPinned", val);
        }
      },
    },
    userDetails() {
      return this.$store.getters["chat/activeConversation"].messengerUser;
    },
    getStatusColor() {
      return isActiveUser => {
        const userStatus = this.getUserStatus(isActiveUser);

        if (userStatus === "online") {
          return "success";
        } else if (userStatus === "do not disturb") {
          return "danger";
        } else if (userStatus === "away") {
          return "warning";
        } else {
          return "grey";
        }
      };
    },
  },
  methods: {
    getUserStatus(isActiveUser) {
      return isActiveUser ? this.$store.state.AppActiveUser.status : this.userDetails.status;
    },
  },
};
</script>

<style scoped>
.venue-divider {
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid #afafaf;
}
</style>